import { Col, Card, Row } from "react-bootstrap";
import Address from "../Address";
import Contact from "../Contact";
import EmergencyContact from "../EmergencyContact";
import moment from "moment";
import { DateFormat } from "../../Helper";
const DemographicInfo = ({ user, user_type, border }) => {
  return (
    <Card className="my-3" border={border ? border : "primary"}>
      <Card.Header as="h5">
        {user.first_name} {user.last_name}&nbsp;
        {user?.emp_data ? (
          <span className="badge bg-primary">
            {user.emp_data.role.designation}
          </span>
        ) : (
          "- " + user?.user_kapid_id.toUpperCase()
        )}
        {/* {user?.user_kapid_id?.toUpperCase()} */}
      </Card.Header>
      <Card.Body>
        <Row md={3}>
          <Col>
            {/* <p>
                No: <strong>{patient.patient?.bp_patient_code}</strong>
              </p> */}
            <Address addresses={user.addresses} />
            <Contact contacts={user.contacts} />
            Dob :{" "}
            <strong>
              <DateFormat value={user.dob} />
            </strong>
            <br />
            Gender : <strong>{user.gender || "Unknown"}</strong>
            <br />
            Blood Group : <strong>{user.bloodGroup || "Unknown"}</strong>
            <hr className="d-xs-block d-sm-block d-md-none" />
          </Col>
          <Col>
            Emergency Contact : <br />
            <EmergencyContact emergency={user.emergency_contacts} />
            {user.dod !== undefined && (
              <p>
                Dod : <strong>{moment(user.dod).format("DD/MM/yyyy")}</strong>
              </p>
            )}
            {/* <p>Status : <strong>Unnown</strong></p> */}
          </Col>
          {user_type === "patient" && (
            <>
              <Col sm={{ order: "first" }} md={{ order: "last" }}>
                {user.lastVisit !== undefined && (
                  <p>
                    Last known visit :{" "}
                    <strong>
                      {moment(user.lastVisit).format("DD/MM/yyyy")}
                    </strong>
                  </p>
                )}
                {user.lastServiceTaken !== undefined && (
                  <p>
                    Last known Service :{" "}
                    <strong>{user.lastServiceTaken}</strong>
                  </p>
                )}
                <hr className="d-xs-block d-sm-block d-md-none" />
              </Col>
            </>
          )}
          {user_type === "staff" && user.emp_data && (
            <>
              <Col xs={{ order: "first" }} md={{ order: "last" }}>
                <h5>{user.emp_data.emp_type_name}</h5>
                Role : <strong>{user.emp_data.role.role_name}</strong>
                <br />
                Org Code : <strong>{user.emp_data.bp_emp_org_code}</strong>
                <br />
                <span>Official Contacts : </span>
                <br />
                <Contact contacts={user.emp_data.official_contacts} />
                Branch : <strong>{user.emp_data.bp_branch_name}</strong>
                <br />
                Joining Date :
                <strong>
                  <DateFormat value={user.emp_data.effective_from_date} />
                </strong>
                <hr className="d-none d-xs-block d-sm-block d-md-none" />
              </Col>
            </>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};
export default DemographicInfo;
